import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Criteria() { 
  useEffect(() => {
    document.title = 'Criteria -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> Admission  </li>
                <li>Criteria</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Criteria</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p>Registration and Admission Procedure</p>
               <p>The registration process for the new academic session begins on the <b>1st of December</b> each year, as announced by the school. The registration forms can be obtained from the <b>School Office</b> on all working days between <b> 9:00 a.m. to 11:00 a.m.</b> Completed forms should be returned to the office as specified. The date for the admission test will be notified on the counterfoil attached to the Registration Form.</p>

                
                <h5>Admission to Standard I:</h5>
                   <p><b> Eligibility: </b></p>
                   <p> Admission is open to all students, irrespective of class, creed, or community. Admission to <b>Class 1 (First)</b> is typically given to students who have attained the age of <b>6+ years</b> at the commencement of the academic year. A child’s name will not be registered for admission unless the <b>original Computerized Birth Certificate</b> from Nagar Nigam is produced.</p>
               <h5>Admission Criteria:</h5>
               <p>The registration of a child's name does not guarantee admission. The admission process depends on the following criteria:</p>
               <ul className="mainlist">
                <li> The child must attain the prescribed minimum standard in the Admission Test (if applicable).</li>
                <li>  Once the applicant qualifies in the admission test, admission will depend on the number of seats available in the class.</li>
                <li> If the parent fails to submit required documents or reasons, the application may be disqualified.</li>
               </ul>
               
               <h5>Admission to Classes II to VIII:</h5>
               <p><b>Admission Criteria:</b></p>
                <p>Admission to classes II to VIII is based on vacancies available in these classes. If vacancies exist, applications will be accepted from the second week of March to the last week of March each year, until further notice. Applications should be addressed directly to the Principal. Please mention the class you are interested in, along with clear contact information (email address and phone numbers).</p>
                <ul className="mainlist">
                <li> Attach a copy of the birth certificate and the latest progress report of the child with the application. </li>
               </ul>
               
                <p><b> Important Notes:</b></p>
                <ul className="mainlist">
               <li> Incomplete applications will be disqualified.  </li>
               <li> The last date for submission of applications will be displayed on the school website: mercymemorialschool.com. </li>
               <li> Late applications will not be entertained.  </li>
               <li> The school office will contact applicants if a vacancy arises. </li>
               </ul>
               <h5>Admission to Nursery, Playgroup, Preparatory and Class I:</h5>
               <p><b>Availability of Forms:</b></p>
                <p>Registration forms for Nursery, Playgroup, Preparatory and Class I will be available in the third week of December.</p>
                <p> Process: Filled-in forms must be submitted to the School Office as mentioned on the form. An admission test will be conducted as notified for all classes.</p>
                <p><b>Age Requirements: </b></p>
                <ul className="mainlist">
                  <li><b>Playgroup: </b>3 to 3.5 years  </li>
               <li><b> Nursery: </b>4 to 4.5 years  </li>
               <li><b> Preparatory:</b> 5 to 5.5 years  </li>
               <li><b> Class I:</b> 6 to 6.5 years </li>
               </ul>
               <p><b>Interactive Session:</b></p>
               <p> Parents are required to attend an interactive session with the Headmistress as part of the admission process.</p>
               <p><b>Documents Required for Admission: </b></p>
               <ul className="mainlist">
                <li> Birth Certificate  </li>
                <li> Transfer Certificate (if applicable)  </li>
               <li>  Report Card from the previous school/class attended (if applicable)  </li>
               <li>  Aadhaar Card Copy (as address proof)  </li>
               <li>  Blood Group Details of the candidate  </li>
               <li>  Height & Weight details of the candidate </li>
               </ul> 
               </div>
               
               
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Criteria;
